import { render, staticRenderFns } from "./articlesList.vue?vue&type=template&id=869d5184"
import script from "./articlesList.vue?vue&type=script&lang=js"
export * from "./articlesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports